import {connect} from "react-redux"
import {createSelector} from "reselect"
import {IncomingHttpHeaders} from "http"
import {State} from "../../ducks"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import {REALM_HEADER} from "../../config/constants"
import {isRelativePath} from "../../utils/configUrlPath"

// Selector for quickLinkObject
const selectQuickLinkObject = (state: State) =>
    state.data?.regions.find(region => region.type === SupportedRegionTypes.BurgerMenu)
const selectSiteUrl = (state: State) => state.request.siteUrl
const selectRealm = (state: State) => (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
const selectIconsVersionPath = (state: State) => state.settings.iconsVersionPath

// Memoized selector for quickLinks
const makeSelectQuickLinks = createSelector(
    [selectQuickLinkObject, selectSiteUrl, selectRealm, selectIconsVersionPath],
    (quickLinkObject, siteUrl, realm, iconsVersionPath) => {
        return quickLinkObject?.elements
            .filter(link => link.type === (SupportedRegionSubTypes.Link as string))
            .map(({text, description, url, accessibilityText, icon}) => {
                const iconUrl = icon ? formatCdnPathWithVariant(icon, realm, undefined, iconsVersionPath) : null
                return {
                    text,
                    description,
                    url: isRelativePath(url) ? `${siteUrl}${url as string}` : url,
                    accessibilityText: accessibilityText ?? "",
                    icon: iconUrl,
                }
            })
    },
)

export const mapStateToProps = (state: State) => ({
    quickLinks: makeSelectQuickLinks(state),
    siteUrl: selectSiteUrl(state),
})

export default connect(mapStateToProps)
